import { render } from "./AppMain.vue?vue&type=template&id=0f4c28e4&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=0f4c28e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4c28e4"]])

export default __exports__